<script lang="ts">
  import type { Object3D, Object3DEventMap } from 'three'
  import TransformBase from './TransformBase.svelte'
  import i18n from '../../../../../i18n'
  import { ThreeItemKeys, ThreeItemTypes } from '../../../../../constants/three'
  import useObjectQueries from '../../../hooks/useObjectQueries'

  const { object }: { object: Object3D<Object3DEventMap> } = $props()

  const { useObject, updateUserDataMutation } = useObjectQueries()
  const data = $derived(useObject(object.uuid))

  const axes = {
    x: ThreeItemKeys.ROTATION_LOCKED_X,
    y: ThreeItemKeys.ROTATION_LOCKED_Y,
    z: ThreeItemKeys.ROTATION_LOCKED_Z,
  }
</script>

{#key data.dataUpdatedAt}
  {#if data.data}
    <TransformBase
      getLocked={(obj, axis) =>
        obj.userData[ThreeItemKeys.ITEM_TYPE] === ThreeItemTypes.FILE
          ? obj.userData[axes[axis]]
          : obj.parent?.userData[ThreeItemKeys.LOCKED] || obj.userData[axes[axis]]}
      getValue={(obj, axis) =>
        Math.round(obj.rotation[axis] * (180 / Math.PI) * 10) / 10}
      object={data.data}
      setLocked={(obj, axis, value) => updateUserDataMutation.mutate({ objectUuid: object.uuid, object: { [axes[axis]]: value } })}
      setValue={(obj, axis, value) =>
      (obj.rotation[axis] = value * (Math.PI / 180))}
      title={$i18n.t('project.rightBar.position.rotation')}
      unit="°"
    />
  {/if}
{/key}
